<div class="flex justify-center w-screen flex-1"
     [class.ucb-detail-layout]="(isR8Report || isAviReport || loading) && !(pdfView$ | async)"
     [class.inspector-active]="showInspect$ | async">
    <app-navigation-rail *ngIf="(isR8Report || isAviReport || loading) && !(pdfView$ | async)" active="cases"></app-navigation-rail>
    <div *ngIf="(pdfView$ | async)" class="fixed inset-0 bg-gray-100 flex justify-center items-center z-50">
        <div class="bg-white p-6 rounded-lg shadow-xl">
            <p class="text-lg font-semibold text-gray-800">Generating PDF...</p>
        </div>
    </div>

    <div id="content-to-print" class="min-h-full flex-grow overflow-y-auto"
         [class.container]="(!isR8Report && !loading) || (pdfView$ | async)"
         [class.ucb-detail-content]="(isR8Report || isAviReport || loading) && !(pdfView$ | async)"
         [class.with-inspector]="showInspect$ | async"
         [style.width]="(showInspect$ | async) && !isR8Report ? 'calc(100% - ' + inspectorWidth + 'px)' : null"
         [style.max-width]="(showInspect$ | async) && !isR8Report ? 'none' : null">
        <app-navbar *ngIf="!(pdfView$ | async)"></app-navbar>

        <div *ngIf="loading" class="diligence-loading-state" role="status" aria-live="polite">
            <mat-spinner *ngIf="loading"></mat-spinner>
            <span>Loading report…</span>
        </div>

        <div *ngIf="error">
            <p class="text-xl font-semibold text-red-600 w-full text-center">{{error}}</p>
        </div>

        <div *ngIf="(pdfView$ | async)">
            <app-pdf-header></app-pdf-header>
            <div *ngIf="isReportVoided" class="text-center mt-2">
                <div class="inline-block px-4 py-1 bg-red-500 text-white font-bold rounded-md">
                    REPORT VOIDED - CREDIT RETURNED TO CUSTOMER
                </div>
            </div>
        </div>
        <ng-container
            *ngIf="!isAviReport && ((diligence?.creditsafeData && isReportReady(originalDiligence)) || (isR8Report && isReportReady(originalDiligence)) || (originalDiligence && isAdmin$ | async))">
            <div *ngIf="!isR8Report" class="flex justify-between px-auto text-center align-center items-center p-3 w-full bg-bgColor shadow">
                <div *ngIf="diligence?.report">
                    <div class="w-full text-center font-semibold text-[20px] p-2">
                        {{packageName}} Report
                        <span *ngIf="isReportVoided" class="ml-2 text-sm font-bold px-2 py-1 rounded-full" 
                              matTooltip="This report has been voided and the credit has been returned to account">
                            VOIDED
                        </span>
                    </div>
                </div>
                <div class="space-x-2">
                    <button *ngIf="!(pdfView$ | async)" mat-raised-button color="secondary" (click)="generatePDF()">Download
                        <mat-icon>download</mat-icon>
                    </button>
                </div>
            </div>

            <main *ngIf="isR8Report && !(pdfView$ | async)" class="ucb-report">
                <div class="ucb-report__layout">
                    <header class="ucb-report__hero">
                        <p class="tevuna-section-kicker">Vessel UCB · Structured ownership delivery</p>
                        <h1>Vessel UCB</h1>
                        <p *ngIf="r8Report.vesselImo">IMO {{r8Report.vesselImo}}</p>
                        <button *ngIf="!(pdfView$ | async)" mat-raised-button color="secondary" (click)="generatePDF()">
                            Download <mat-icon>download</mat-icon>
                        </button>
                    </header>
                <section class="ucb-report__section">
                    <h2>Vessel IMO &amp; Core Parties</h2>
                    <div class="ucb-report__grid">
                        <article *ngIf="r8Report.shipOwner" class="ucb-report__card">
                            <h3>Ship Owner</h3>
                            <dl><div *ngIf="r8Report.shipOwner.name"><dt>Name</dt><dd>{{r8Report.shipOwner.name}}</dd></div><div *ngIf="r8Report.shipOwner.tevunaId"><dt>Tevuna ID</dt><dd>{{r8Report.shipOwner.tevunaId}}</dd></div><div *ngIf="r8Report.shipOwner.registeredAddress"><dt>Address</dt><dd>{{r8Report.shipOwner.registeredAddress}}</dd></div><div *ngIf="r8Report.shipOwner.city"><dt>City</dt><dd>{{r8Report.shipOwner.city}}</dd></div><div *ngIf="r8Report.shipOwner.country"><dt>Country</dt><dd>{{r8Report.shipOwner.country}}</dd></div><div *ngIf="r8Report.shipOwner.email"><dt>Email</dt><dd>{{r8Report.shipOwner.email}}</dd></div><div *ngIf="r8Report.shipOwner.phone"><dt>Phone</dt><dd>{{r8Report.shipOwner.phone}}</dd></div><div *ngIf="r8Report.shipOwner.confidenceScore"><dt>Confidence</dt><dd>{{r8Report.shipOwner.confidenceScore}}</dd></div></dl>
                        </article>
                        <article *ngIf="r8Report.shipManager" class="ucb-report__card">
                            <h3>Ship Manager</h3>
                            <dl><div *ngIf="r8Report.shipManager.name"><dt>Name</dt><dd>{{r8Report.shipManager.name}}</dd></div><div *ngIf="r8Report.shipManager.tevunaId"><dt>Tevuna ID</dt><dd>{{r8Report.shipManager.tevunaId}}</dd></div><div *ngIf="r8Report.shipManager.registeredAddress"><dt>Address</dt><dd>{{r8Report.shipManager.registeredAddress}}</dd></div><div *ngIf="r8Report.shipManager.city"><dt>City</dt><dd>{{r8Report.shipManager.city}}</dd></div><div *ngIf="r8Report.shipManager.country"><dt>Country</dt><dd>{{r8Report.shipManager.country}}</dd></div><div *ngIf="r8Report.shipManager.email"><dt>Email</dt><dd>{{r8Report.shipManager.email}}</dd></div><div *ngIf="r8Report.shipManager.phone"><dt>Phone</dt><dd>{{r8Report.shipManager.phone}}</dd></div><div *ngIf="r8Report.shipManager.confidenceScore"><dt>Confidence</dt><dd>{{r8Report.shipManager.confidenceScore}}</dd></div></dl>
                        </article>
                    </div>
                </section>
                <section *ngIf="r8Report.ownershipLevels.length" class="ucb-report__section">
                    <h2>Ownership Levels</h2>
                    <div class="ucb-report__grid">
                        <article class="ucb-report__card" *ngFor="let level of r8Report.ownershipLevels; let i = index">
                            <h3>Level {{i + 1}}</h3>
                            <dl><div *ngIf="level.name"><dt>Name</dt><dd>{{level.name}}</dd></div><div *ngIf="level.address"><dt>Address</dt><dd>{{level.address}}</dd></div><div *ngIf="level.city"><dt>City</dt><dd>{{level.city}}</dd></div><div *ngIf="level.country"><dt>Country</dt><dd>{{level.country}}</dd></div><div *ngIf="level.email"><dt>Email</dt><dd>{{level.email}}</dd></div><div *ngIf="level.website"><dt>Website</dt><dd>{{level.website}}</dd></div></dl>
                        </article>
                    </div>
                </section>
                <section *ngIf="r8Report.ubos.length" class="ucb-report__section">
                    <h2>Ultimate Beneficial Owners</h2>
                    <div class="ucb-report__grid">
                        <article class="ucb-report__card" *ngFor="let ubo of r8Report.ubos; let i = index">
                            <h3>UBO {{i + 1}} · {{ubo.name}}</h3>
                            <dl><div *ngIf="ubo.country"><dt>Country</dt><dd>{{ubo.country}}</dd></div><div *ngIf="ubo.percentage"><dt>Ownership</dt><dd>{{ubo.percentage}}</dd></div><div *ngIf="ubo.startDate"><dt>Start date</dt><dd>{{ubo.startDate}}</dd></div><div *ngIf="ubo.confidence"><dt>Confidence</dt><dd>{{ubo.confidence}}</dd></div><div *ngIf="ubo.entityType"><dt>Entity type</dt><dd>{{ubo.entityType}}</dd></div></dl>
                            <div *ngIf="ubo.reasoning" class="ucb-report__reasoning"><strong>Reasoning</strong><p>{{ubo.reasoning}}</p></div>
                        </article>
                    </div>
                </section>
                </div>
                <section *ngIf="r8Report.references.length" class="ucb-report__section ucb-report__references-panel">
                    <h2>References</h2>
                    <ol class="ucb-report__references"><li *ngFor="let reference of r8Report.references"><a [href]="reference" target="_blank" rel="noopener">{{reference}}</a></li></ol>
                </section>
            </main>

            <section *ngIf="isR8Report && showR8AdminControls && (isAdmin$ | async) && !(pdfView$ | async)" class="ucb-admin-panel">
                <app-modify-diligence [diligence]="diligence"
                    (updateDiligence)="updateDiligence()"
                    (voidStatusChanged)="handleVoidStatusChanged($event)"></app-modify-diligence>
            </section>

            <!-- R9 Cover Section (rendered outside tabs) -->
            <div *ngIf="!isR8Report && currentReportSpec?.coverSections" class="report-cover-section mb-6 p-4 bg-white shadow-md">
                <app-universal-report-renderer [tab]="{ id: 'cover', title: 'Cover', display: true, sections: currentReportSpec?.coverSections || [] }"></app-universal-report-renderer>
            </div>

            <ng-container *ngIf="!isR8Report && !(pdfView$ | async) && (((sections$ | async) || []).length > 0 || (isAdmin$ | async))">
                <mat-tab-group [selectedIndex]="selectedEditorTabIndex"
                               (selectedIndexChange)="selectedEditorTabIndex = $event">
                    <mat-tab *ngFor="let section of visibleSections$ | async" [label]="section.title">
                        <ng-template matTabContent>
                            <ng-container
                                *ngComponentOutlet="section.component; inputs: section.data"></ng-container>
                        </ng-template>
                    </mat-tab>
                    <mat-tab *ngIf="(isAdmin$ | async)" label="Admin">
                        <ng-template matTabContent>
                            <app-modify-diligence [diligence]="diligence"
                                (updateDiligence)="updateDiligence()"
                                (voidStatusChanged)="handleVoidStatusChanged($event)"></app-modify-diligence>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </ng-container>

            <ng-container *ngIf="!isR8Report && (pdfView$ | async) && ((sections$ | async) || []).length > 0">
                <ng-container *ngFor="let section of (printableSections$ | async)">
                    <div class="pdf-section">
                        <ng-container *ngComponentOutlet="section.component; inputs: section.data"></ng-container>
                    </div>
                </ng-container>
                <app-disclaimer></app-disclaimer>
            </ng-container>
        </ng-container>
        <app-avi-report *ngIf="isAviReport && !(pdfView$ | async)" [uuid]="diligence?.uuid" [report]="diligence"></app-avi-report>
    </div>
    
    <!-- Resize handle positioned between main content and inspector -->
    <div class="resize-handle" *ngIf="showInspect$ | async" (mousedown)="startResize($event)"></div>
    
    <!-- Spec Editor Panel -->
    <div class="inspector-panel" *ngIf="showInspect$ | async" [style.width.px]="inspectorWidth">
        <!-- Header with actions -->
        <div class="bg-gray-800 text-white p-2 font-semibold border-b flex justify-between items-center">
            <span>Report Editor</span>
            <div class="flex items-center space-x-1">
                <button mat-icon-button
                        (click)="saveSpec()"
                        [disabled]="!specDirty || savingSpec"
                        matTooltip="Save Changes"
                        [class.text-yellow-400]="specDirty">
                    <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button
                        (click)="regenerateSpec()"
                        [disabled]="savingSpec"
                        matTooltip="Regenerate from data">
                    <mat-icon>refresh</mat-icon>
                </button>
                <button mat-icon-button
                        (click)="showJsonView = !showJsonView"
                        [matTooltip]="showJsonView ? 'Show Editor' : 'Show JSON'">
                    <mat-icon>{{ showJsonView ? 'edit' : 'code' }}</mat-icon>
                </button>
                <button mat-icon-button
                        (click)="downloadJson()"
                        matTooltip="Download JSON">
                    <mat-icon>download</mat-icon>
                </button>
                <button mat-icon-button
                        (click)="toggleInspect()"
                        matTooltip="Close">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Dirty indicator -->
        <div *ngIf="specDirty" class="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 text-center">
            Unsaved changes
        </div>

        <!-- JSON View -->
        <div *ngIf="showJsonView" class="flex-grow overflow-y-auto p-2">
            <ngx-json-viewer [json]="currentReportSpec" [expanded]="false"></ngx-json-viewer>
        </div>

        <!-- Spec Editor View -->
        <div *ngIf="!showJsonView && currentReportSpec" class="flex-grow overflow-y-auto">
            <!-- Tab Selector -->
            <div class="border-b border-gray-200 px-3 py-2 bg-gray-50 flex items-center gap-2">
                <span class="text-sm text-gray-600">Tab:</span>
                <select [(ngModel)]="selectedEditorTabIndex" class="border rounded px-2 py-1 text-sm flex-1">
                    <option *ngFor="let tab of currentReportSpec.tabs; let i = index" [value]="i">
                        {{ tab.title }}
                    </option>
                </select>
            </div>

            <!-- Tab Settings -->
            <div class="px-3 py-2 bg-gray-50 border-b flex items-center gap-3" *ngIf="currentEditorTab">
                <input type="text"
                       [(ngModel)]="currentEditorTab.title"
                       (ngModelChange)="onSpecChanged()"
                       class="border rounded px-2 py-1 text-sm flex-1"
                       placeholder="Tab title">
                <label class="flex items-center gap-1 text-sm">
                    <input type="checkbox"
                           [(ngModel)]="currentEditorTab.display"
                           (ngModelChange)="onSpecChanged()">
                    Visible
                </label>
            </div>

            <!-- Sections List -->
            <div class="p-3" *ngIf="currentEditorTab">
                <div *ngFor="let section of currentEditorTab.sections; let i = index">
                    <app-section-editor
                        [section]="section"
                        [isFirst]="i === 0"
                        [isLast]="i === currentEditorTab.sections.length - 1"
                        [expanded]="i === expandedSectionIndex"
                        (sectionChange)="onSpecChanged()"
                        (delete)="removeSection(i)"
                        (moveUp)="moveSection(i, -1)"
                        (moveDown)="moveSection(i, 1)">
                    </app-section-editor>
                </div>

                <div *ngIf="currentEditorTab.sections.length === 0" class="text-center py-6 text-gray-400 text-sm">
                    No sections. Add one below.
                </div>

                <!-- Add Section Buttons -->
                <div class="flex gap-1 flex-wrap mt-3">
                    <button mat-stroked-button (click)="addSection('text')" class="text-xs">
                        <mat-icon class="scale-75">text_fields</mat-icon> Text
                    </button>
                    <button mat-stroked-button (click)="addSection('list')" class="text-xs">
                        <mat-icon class="scale-75">list</mat-icon> List
                    </button>
                    <button mat-stroked-button (click)="addSection('card')" class="text-xs">
                        <mat-icon class="scale-75">dashboard</mat-icon> Card
                    </button>
                    <button mat-stroked-button (click)="addSection('table')" class="text-xs">
                        <mat-icon class="scale-75">table_chart</mat-icon> Table
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Floating toggle button positioned outside main container -->
<button *ngIf="(isAdmin$ | async) && !(showInspect$ | async) && (!isR8Report || showR8AdminControls)"
        mat-button
        class="inspector-toggle-btn"
        (click)="toggleInspect()">
    Edit Report >
</button>

<app-footer *ngIf="!(pdfView$ | async)"></app-footer>
